<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Técnicos</h1>

    <div class="mb-2 mt-3 d-flex" style="gap: 12px">
      <SGPFormSelectComponent
        name="exibirItensDeletados"
        :listaDeOptions="opcoesSelect"
        v-model="exibirItensDeletados"
        optionLabel="nome"
        placeholder="Visualizar Itens Deletados"
        :error="validationErrors.first('exibirItensDeletados')"
        data-vv-as="Visualizar Itens Deletados"
        optionSelecione="Não"
        @change="filtrarDeletados"
      />
    </div>

    <SGPBotaoAdicionarNovoComponent
      @sgpAdiconarNovoEmit="adicionarNovo"
    />

    <SGPPaginacaoComponent
      :paginacao="paginacao"
      v-if="listaDeTecnicosPaginada.data && listaDeTecnicosPaginada.data.length"
      @sgpAtualizarPaginacao="realizarPaginacao"
    >
      <SGPTabelaAvancadaComponent
        :colunas="colunas"
        :dados="listaDeTecnicosPaginada.data"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
        @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
        @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado"
        selecionarColunas
      />
    </SGPPaginacaoComponent>

    <SGPAlertaComponent v-else />

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Técnicos"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioCtrlTecnicoComponent
        :tipoFormulario="tipoFormulario"
        :ctrlTecnico="ctrlTecnico"
        @fechar="fecharModal"
        @atualizarListagemTabela="aplicarFiltros"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao"
      @sgpConfirmarDelecaoEmit="confirmarDelecao"
    />

    <SGPLoadingComponent v-if="loadingCtrlTecnicos" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioCtrlTecnicoComponent from '../components/FormularioCtrlTecnicoComponent.vue'

export default {
  name: 'CtrlTecnicoPage',

  components: {
    FormularioCtrlTecnicoComponent
  },

  data () {
    return {
      linhasSelecionadas: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      ctrlTecnico: {},
      opcoesSelect: [
        { id: true, nome: 'Sim' },
        { id: false, nome: 'Não' }
      ],
      exibirItensDeletados: false
    }
  },

  computed: {
    ...mapGetters('ctrlTecnicos', [
      'listaDeTecnicosPaginada',
      'loadingCtrlTecnicos'
    ]),

    paginacao () {
      if (!this.listaDeTecnicosPaginada.data) return {}

      return {
        per_page: this.listaDeTecnicosPaginada.per_page,
        total: this.listaDeTecnicosPaginada.total,
        current_page: this.listaDeTecnicosPaginada.current_page
      }
    },

    colunas () {
      return [
        { key: 'selecionar', label: '', sortable: false },
        { key: 'ctrl_provedor.nome', label: 'Provedor', sortable: false },
        { key: 'nome', label: 'Nome Completo', sortable: true },
        { key: 'rg', label: 'RG', sortable: false },
        { key: 'cpf', label: 'CPF', sortable: false }
      ]
    }
  },

  created () {
    this.listarTecnicosComPaginacao()
  },

  methods: {
    ...mapActions('ctrlTecnicos', [
      'listarTecnicosComPaginacao',
      'excluirTecnico',
      'restaurarTecnico'
    ]),

    realizarPaginacao (paginacao) {
      this.listarTecnicosComPaginacao(
        this.montarPayload(paginacao)
      )
    },

    gerenciadorDeSelecionados (selecionados) {
      this.linhasSelecionadas = selecionados
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar'
      this.ctrlTecnico = this.linhasSelecionadas[0]
      this.abrirModal = true
    },

    async restaurarSelecionado (item) {
      await this.restaurarTecnico(item.id)
      await this.listarTecnicosComPaginacao(
        this.montarPayload()
      )
    },

    deletarSelecionado () {
      this.deletarDados = true
    },

    cancelarDelecao () {
      this.deletarDados = false
    },

    async confirmarDelecao () {
      await this.excluirTecnico(this.linhasSelecionadas)

      this.deletarDados = false

      await this.listarTecnicosComPaginacao(
        this.montarPayload()
      )
    },

    adicionarNovo () {
      this.ctrlTecnico = {}
      this.tipoFormulario = 'salvar'
      this.abrirModal = true
    },

    fecharModal () {
      this.abrirModal = false
    },

    filtrarDeletados () {
      this.listarTecnicosComPaginacao(
        this.montarPayload({
          ...this.paginacao,
          current_page: 1
        })
      )
    },

    aplicarFiltros () {
      this.listarTecnicosComPaginacao(
        this.montarPayload()
      )
    },

    montarPayload (paginacao = this.paginacao) {
      return {
        ...paginacao,
        trashed: this.exibirItensDeletados
      }
    }
  }
}
</script>
